// extracted by mini-css-extract-plugin
export default {"container":"NetworkQualityWarning__container--WgU4z"};